import $ from 'jquery';

$('.cardbox__tab-label').on('click', function() {
    $(this).parents('.cardbox__tabs').find('.cardbox__tab').removeClass('cardbox__tab--active');
    $(this).parent().addClass('cardbox__tab--active');
});

$('.cardbox__navigation-item').on('click', function() {
    var $cardbox = $(this).parents('.cardbox');
    $cardbox.find('.cardbox__navigation-item').removeClass('cardbox__navigation-item--active');
    $cardbox.find('.cardbox__tab').removeClass('cardbox__tab--active');
    $cardbox.find('[data-tab="'+ $(this).attr('data-target') +'"]').addClass('cardbox__tab--active');
    $(this).addClass('cardbox__navigation-item--active');
});
